var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-row div-valign" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("\n        เลขที่สัญญา\n        ")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.ctrNoExt,
              expression: "ctrNoExt"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{ required:true}"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("ctrNoExt") },
          attrs: {
            name: "ctrNoExt",
            "data-vv-as": "เลขที่สัญญา",
            disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
            type: "text"
          },
          domProps: { value: _vm.ctrNoExt },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.ctrNoExt = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("ctrNoExt"),
                expression: "errors.has('ctrNoExt')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("ctrNoExt")))]
        )
      ]),
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("\n        ชื่อสัญญา\n      ")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.ctrNameExt,
              expression: "ctrNameExt"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{ required:true}"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("ctrNameExt") },
          attrs: {
            name: "ctrNameExt",
            "data-vv-as": "ชื่อสัญญา",
            disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
            maxlength: "200",
            type: "text"
          },
          domProps: { value: _vm.ctrNameExt },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.ctrNameExt = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("ctrNameExt"),
                expression: "errors.has('ctrNameExt')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("ctrNameExt")))]
        )
      ]),
      _c(
        "div",
        { staticClass: "form-group col-md-6" },
        [
          _c("label", [_vm._v("วันที่ลงสัญญา\n        ")]),
          _c("br"),
          _c("date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{ required:true}"
              }
            ],
            ref: "ctrDateExt",
            class: { input: true, "is-danger": _vm.errors.has("ctrDateExt") },
            attrs: {
              name: "ctrDateExt",
              format: "DD/MM/YYYY",
              disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
              "data-vv-as": "วันที่ลงสัญญา",
              lang: "th",
              placeholder: ""
            },
            model: {
              value: _vm.ctrDateExt,
              callback: function($$v) {
                _vm.ctrDateExt = $$v
              },
              expression: "ctrDateExt"
            }
          }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("ctrDateExt"),
                  expression: "errors.has('ctrDateExt')"
                }
              ],
              staticClass: "help is-danger"
            },
            [_vm._v(_vm._s(_vm.errors.first("ctrDateExt")))]
          )
        ],
        1
      ),
      _c("div", { staticClass: "form-group col-md-12" }, [
        _c("label", [
          _vm._v("\n        รายละเอียดโครงการ/รายละเอียดสัญญา\n        ")
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.beneficiaryRemarkExt,
              expression: "beneficiaryRemarkExt"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{ required:true}"
            }
          ],
          staticClass: "form-control",
          class: {
            input: true,
            "is-danger": _vm.errors.has("beneficiaryRemarkExt")
          },
          attrs: {
            name: "beneficiaryRemarkExt",
            "data-vv-as": "รายละเอียดโครงการ/รายละเอียดสัญญา",
            disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
            type: "text",
            maxlength: "500"
          },
          domProps: { value: _vm.beneficiaryRemarkExt },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.beneficiaryRemarkExt = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("beneficiaryRemarkExt"),
                expression: "errors.has('beneficiaryRemarkExt')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("beneficiaryRemarkExt")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }